import { CgArrowLeft } from "react-icons/cg";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTheme } from "../../../../../../../../../../hooks/WebCheckinUsers/theme";
import { inactiveItens } from "../../../../../../../../../../theme";
import { fileProps } from "../../../../../../../../../../interfaces";
import {
  IInputDocumentRefProps,
  InputDocument,
} from "../../../../../../../../../../components/Inputs/InputFile";
import { UploadIcon } from "../../../../../../../../../../components/SvgComponents/Icons/UploadIcon";
import { MyCircularProgress } from "../../../../../../../../../../components/MyCircularProgress";
import { useApiWebCheckinUser } from "../../../../../../../../../../hooks/WebCheckinUsers/api";
import { useGlobalWebCheckinUser } from "../../../../../../../../../../hooks/WebCheckinUsers/global";

export interface IUploadSelfieFile {
  onNext: (photo: string) => void;
  goBack: () => void;
}

export const UploadSelfieFile: React.FC<IUploadSelfieFile> = ({
  goBack,
  onNext,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { api } = useApiWebCheckinUser();
  const { notify } = useGlobalWebCheckinUser();
  const { colorsTheme } = useTheme();

  const [file, setFile] = useState<fileProps | null>(null);

  const inputFileRef = useRef<IInputDocumentRefProps>(null);

  const transformImageInBase64 = useCallback(
    async (image: fileProps) => {
      setLoading(true);
      setError(null);
      try {
        const formData = new FormData();
        formData.append("photo", image.file);
        const { data } = await api.post("/photos/transform", formData);
        onNext(data.complete);
      } catch (err) {
        console.error(err);
        const message =
          "Não foi possível processar a selfie. Tente novamente com outra imagem.";
        setError(message);
        notify(message, "error");
        setFile(null);
      } finally {
        setLoading(false);
      }
    },
    [api, notify, onNext],
  );

  useEffect(() => {
    if (file) transformImageInBase64(file);
  }, [file, transformImageInBase64]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div
              style={{ position: "absolute", left: 0 }}
              className="pointer"
              onClick={() => goBack()}
            >
              <CgArrowLeft color={inactiveItens.light} size={20} />
            </div>
            <div>Foto da selfie</div>
          </div>
        </div>
        <div style={{ display: "flex", flex: 1 }}>
          <div style={{ display: "none" }}>
            <InputDocument
              ref={inputFileRef}
              onChange={(e) => {
                setError(null);
                setFile(e);
              }}
              fileTypes={["jpeg", "jpg"]}
            />
          </div>
          <div
            onClick={() => (!loading ? inputFileRef.current?.focus() : 0)}
            style={{
              display: "flex",
              padding: 20,
              justifyContent: "center",
              alignItems: "center",
              border: `2px dashed ${error ? "#E53E3E" : "#E5E5E5"}`,
              borderRadius: 8,
              flexDirection: "column",
              flex: 1,
              cursor: !loading ? "pointer" : "default",
              marginBottom: 20,
            }}
          >
            {!loading && (
              <>
                <UploadIcon background={colorsTheme.secondary.light} />
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 18,
                    textAlign: "center",
                    maxWidth: 280,
                    marginTop: 20,
                  }}
                >
                  Clique aqui ou arraste um arquivo para carregar
                </div>
                <div style={{ fontSize: 14 }}>Formato JPG ou JPEG.</div>
                {error && (
                  <div
                    style={{
                      fontSize: 14,
                      color: "#E53E3E",
                      textAlign: "center",
                      maxWidth: 280,
                      marginTop: 16,
                    }}
                  >
                    {error}
                  </div>
                )}
              </>
            )}
            {loading && (
              <>
                <MyCircularProgress size={30} color={colorsTheme.secondary.light} />
                <div style={{ marginTop: 20, fontWeight: "bold" }}>
                  Carregando selfie
                </div>
                <div style={{ fontSize: 14 }}>Processando a imagem...</div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
